<template>
    <div class="mv-mitglieder-filter" @keyup.enter="onSubmit" tabindex="0">
        <h3>Filter</h3>
        <b-form @submit="onSubmit" @reset="onReset">
            <b-form-group
                description
                label-cols-sm="2"
                label="ID, Name:"
                label-for="inputFilterName"
                :label-size="size"
            >
                <b-form-input
                    id="inputFilterName"
                    v-model="filter.id_name"
                    :size="size"
                />
            </b-form-group>
            <b-form-group
                description
                label-cols-sm="2"
                label="Einschränkungen:"
                label-for="inputFilterExclude"
                :label-size="size"
            >
                <b-form-select id="inputFilterExclude" :size="size" disabled />
            </b-form-group>
            <b-form-group
                v-if="!werke.forbidden"
                description
                label-cols-sm="2"
                label="Besetzung:"
                label-for="inputFilterBesetzung"
                :label-size="size"
            >
                <template v-slot:label>
                    <template v-if="werke.busy">
                        <ContentLoadingBlock class="inline" />
                    </template>
                    <template v-else>Besetzung:</template>
                </template>

                <template v-if="werke.busy">
                    <ContentLoadingBlock />
                </template>
                <template v-else>
                    <b-form-select
                        id="inputFilterBesetzung"
                        :size="size"
                        :options="werke.items"
                        placeholder="Ohne Beschänkung"
                        :disabled="werke.busy"
                        v-model="filter.werke"
                    />
                </template>
            </b-form-group>
            <b-form-group
                v-if="!schoolyears.forbidden"
                description
                label-cols-sm="2"
                label="SP-Schuljahre:"
                label-for="inputFilterSPSchoolyears"
                :label-size="size"
            >
                <template v-slot:label>
                    <template v-if="schoolyears.busy">
                        <ContentLoadingBlock class="inline" />
                    </template>
                    <template v-else>SP-Schuljahre:</template>
                </template>

                <template v-if="schoolyears.busy">
                    <ContentLoadingBlock />
                </template>
                <template v-else>
                    <b-form-select
                        id="inputFilterSPSchoolyears"
                        :size="size"
                        :options="schoolyears.items"
                        placeholder="Alle Schuljahre"
                        :disabled="schoolyears.busy"
                        v-model="filter.schoolyear"
                    />
                </template>
            </b-form-group>
            <b-form-group
                description
                label-cols-sm="2"
                label="zusätzliche Spalten:"
                label-for="inputFilterAdditional"
                :label-size="size"
            >
                <CheckboxSelect
                    id="inputFilterAdditional"
                    v-model="fields.selected"
                    :options="fields.all"
                    :selectSize="fields.selectSize"
                    :size="size"
                />
            </b-form-group>
            <b-form-group
                v-if="!status.forbidden"
                description
                label-cols-sm="2"
                label-for="inputFilterStatus"
                :label-size="size"
            >
                <template v-slot:label>
                    <template v-if="status.isBusy">
                        <ContentLoadingBlock />
                    </template>
                    <template v-else>Status:</template>
                </template>

                <template v-if="status.isBusy">
                    <ContentLoadingBlock height="150px" />
                </template>
                <template v-else>
                    <CheckboxSelect
                        id="inputFilterStatus"
                        v-model="filter.status"
                        :options="status.items"
                        :selectSize="status.selectSize"
                        :size="size"
                        :isBusy="status.isBusy"
                        :sortActive="true"
                    />
                </template>
            </b-form-group>
            <b-form-group
                v-if="!statuserweiterung.forbidden"
                description
                label-cols-sm="2"
                label-for="inputFilterStatuserweiterung"
                :label-size="size"
            >
                <template v-slot:label>
                    <template v-if="statuserweiterung.isBusy">
                        <ContentLoadingBlock />
                    </template>
                    <template v-else>Statuserweiterung:</template>
                </template>

                <template v-if="statuserweiterung.isBusy">
                    <ContentLoadingBlock height="150px" />
                </template>
                <template v-else>
                    <CheckboxSelect
                        id="inputFilterStatuserweiterung"
                        v-model="filter.statuserweiterung"
                        :options="statuserweiterung.items"
                        :selectSize="statuserweiterung.selectSize"
                        :size="size"
                        :isBusy="statuserweiterung.isBusy"
                        :sortActive="true"
                    />
                </template>
            </b-form-group>
            <b-form-group
                label="Mitglieder ohne E-Mail:"
                label-for="withoutEmail:"
                label-cols-sm="2"
                :label-size="size"
            >
                <b-form-checkbox
                    id="withoutEmail"
                    v-model="filter.withoutEmail"
                    name="withoutEmail"
                    value="withoutEmail"
                    :unchecked-value="null"
                ></b-form-checkbox>
            </b-form-group>
            <b-form-group>
                <b-button
                    variant="primary"
                    @click="onSubmit"
                    :size="size"
                    class="total-btn"
                    >Anzeigen</b-button
                >
                <b-button
                    type="reset"
                    variant="outline-danger"
                    :size="size"
                    class="total-btn"
                    >Felder zurücksetzen</b-button
                >
            </b-form-group>
        </b-form>
    </div>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import SingPause from "@/mixins/SingPause/SingPause";
import CheckboxSelect from "@/components/CheckboxSelect/CheckboxSelect";
import ContentLoadingBlock from "@/components/ContentLoadingBlock/ContentLoadingBlock";
import "./MitgliederFilter.scss";

const MitgliederApi = ApiFactory.get("mitglieder");
const StatusApi = ApiFactory.get("status");
const StatuserweiterungApi = ApiFactory.get("statuserweiterung");
const WerkeApi = ApiFactory.get("werke");
const SingPauseApi = ApiFactory.get("singpause");

export default {
    name: "MitgliederFilter",
    mixins: [SingPause],
    components: {
        CheckboxSelect,
        ContentLoadingBlock
    },
    data() {
        return {
            fields: {
                selectSize: 5,
                selected: [
                    "id",
                    "status",
                    "photo_id",
                    "anrede",
                    "titel",
                    "vorname",
                    "name"
                ],
                all: [
                    { value: "id", text: "ID" },
                    { value: "status", text: "Status" },
                    { value: "statuserweiterung", text: "Statuserweiterung" },
                    { value: "photo_id", text: "Foto" },
                    { value: "anrede", text: "Anrede" },
                    { value: "titel", text: "Titel" },
                    { value: "vorname", text: "Vorname" },
                    { value: "name", text: "Name" },
                    { value: "name2", text: "Name 2" },
                    { value: "strasse", text: "Strasse" },
                    { value: "plz", text: "PLZ" },
                    { value: "ort", text: "Ort" },
                    { value: "contact_mail", text: "E-Mail" },
                    { value: "contact_phone", text: "Telefon" },
                    { value: "contact_fax", text: "Fax" },
                    { value: "contact_website", text: "Webseite" },
                    { value: "geburtstag", text: "Geburtstag" },
                    { value: "eintritt", text: "Eintritt" },
                    { value: "austritt", text: "Austritt" },
                    { value: "todesdatum", text: "Todesdatum" },
                    { value: "swift", text: "IBAN" },
                    { value: "bemerkung_new", text: "Bemerkung" },
                    { value: "sp_since", text: "SingPause Beginn" }
                ]
            },
            filter: {
                id_name: "",
                status: [],
                statuserweiterung: [],
                werke: null,
                schoolyear: null,
                honoraryear: null,
                withoutEmail: null
            },
            status: {
                forbidden: false,
                isBusy: false,
                selectSize: 5,
                items: []
            },
            statuserweiterung: {
                forbidden: false,
                isBusy: false,
                selectSize: 5,
                items: []
            },
            werke: {
                forbidden: false,
                busy: false,
                items: [
                    {
                        value: null,
                        text: "Ohne Beschränkung"
                    }
                ]
            },
            schoolyears: {
                forbidden: false,
                busy: false,
                items: [
                    {
                        value: null,
                        text: "Ohne Schuljahresbeschränkung"
                    }
                ]
            }
        };
    },
    created() {
        this.getStoredSettings();

        this.fetchStatus();
        this.fetchStatuserweiterung();
        this.fetchWerke();
        this.fetchSPSchoolYears();

        window.addEventListener("keyup", this.handleEnterKeyUp);
    },
    beforeDestroy() {
        window.removeEventListener("keyup", this.handleEnterKeyUp);
    },
    watch: {
        fields: {
            handler(value) {
                this.$root.$emit(
                    "mv::mitglieder::fields::changed",
                    value.selected
                );
            },
            deep: true,
            immediate: true
        },
        filter: {
            handler(value) {
                this.$root.$emit("mv::mitglieder::filter::changed", value);
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        size() {
            const settings = this.$store.getters.getSettings;
            return settings.size;
        },
        storedFieldsSelected() {
            const pages = this.$store.getters.getPages;
            if (pages.mitglieder) {
                return pages.mitglieder.fields;
            }
            return null;
        },
        storedFilter() {
            const pages = this.$store.getters.getPages;
            if (pages.mitglieder) {
                return pages.mitglieder.filter;
            }
            return null;
        }
    },
    methods: {
        async fetchStatuserweiterung() {
            this.statuserweiterung.isBusy = true;
            const response = await StatuserweiterungApi.get();
            if (response.ok) {
                const statuserweiterung = response.json.collection;
                var map = statuserweiterung.map(se => {
                    return { value: se.id, text: se.bezeichnung };
                });
                this.statuserweiterung.items = map;
            } else if (response.status === 403) {
                this.statuserweiterung.forbidden = true;
            }

            this.statuserweiterung.isBusy = false;
        },
        async fetchStatus() {
            this.status.isBusy = true;
            const response = await StatusApi.get();

            if (response.ok) {
                const status = response.json.collection;

                var map = status.map(status => {
                    return {
                        value: status.value,
                        text: status.value + " (" + status.name + ")"
                    };
                });

                this.status.items = map;
            } else if (response.status === 403) {
                this.status.forbidden = true;
            }
            this.status.isBusy = false;
        },
        async fetchWerke() {
            this.werke.busy = true;
            const response = await WerkeApi.get();
            if (response.ok) {
                var items = response.json.collection;
                items = items.map(item => {
                    return {
                        value: item.id,
                        text:
                            item.bezeichnung +
                            " - " +
                            this.$moment(item.verfallsdatum).format("DD.MM.Y")
                    };
                });
                this.werke.items = this.werke.items.concat(items);
            } else if (response.status === 403) {
                this.werke.forbidden = true;
            }
            this.werke.busy = false;
        },
        async fetchSPSchoolYears() {
            this.schoolyears.busy = true;
            const response = await SingPauseApi.getSchoolYears();
            if (response.ok) {
                var items = response.json.collection;
                items = items
                    .sort((a, b) => b - a)
                    .map(item => {
                        return {
                            value: item,
                            text: this.printSchoolYear(item)
                        };
                    });
                this.schoolyears.items = this.schoolyears.items.concat(items);
            } else if (response.status === 403) {
                this.schoolyears.forbidden = true;
            }
            this.schoolyears.busy = false;
        },
        reset() {
            this.filter = {
                id_name: "",
                status: [],
                statuserweiterung: [],
                werke: null,
                schoolyear: null
            };
        },
        getStoredSettings() {
            if (this.storedFieldsSelected) {
                this.fields.selected = this.storedFieldsSelected;
            }
            if (this.storedFilter) {
                this.filter = this.storedFilter;
            }

            this.submitFilter(false);
        },
        processFilter() {
            var filter = Object.assign({}, this.filter);
            var processedFilter = {};
            for (const prop in filter) {
                if (filter[prop] !== null) {
                    processedFilter[prop] = filter[prop];
                }
            }
            return processedFilter;
        },
        handleEnterKeyUp(evt) {
            if (evt.key === "Enter") {
                this.submitFilter();
            }
        },
        submitFilter() {
            MitgliederApi.abort();
            const fields = this.fields.selected.slice(0);
            const filter = this.processFilter();

            this.$store.dispatch("pages", {
                mitglieder: {
                    fields: fields,
                    filter: filter
                }
            });

            this.$emit("submitFilter", {
                fields: fields,
                filter: { ...this.filter }
            });

        },
        onSubmit(evt) {
            evt.preventDefault();

            this.submitFilter();
        },
        onReset(evt) {
            evt.preventDefault();
            this.reset();

            this.submitFilter();
        }
    }
};
</script>
